import { cn } from "@omni/utils/styles";

import { useSearchComponentStateSelector } from "@/redux/modules/value/search/search.selectors";
import { AlgoliaSearchHit } from "@/services/algolia/types/search.types";
import { ContentPageAlgoliaModel } from "@/types/service/product/algolia/contentPage.algolia.model";
import { ResultListHit } from "@/utils/search/types/internal/resultListHit";
import { SearchComponent } from "@/utils/search/types/searchComponent";

import { ContentResultListHitComponent } from "./components/hit/contentResultListHit.component";
import { ResultList } from "./resultList.container";

type Props = {
    className?: string;
};

export const ContentResultListComponent = ({ className }: Props) => {
    const resultListComponentState = useSearchComponentStateSelector(
        SearchComponent.CONTENT_RESULT_LIST
    );

    const hits = resultListComponentState?.hits as
        | Array<ResultListHit<AlgoliaSearchHit<ContentPageAlgoliaModel>>>
        | undefined;

    if (!hits?.length) return null;

    return (
        <ResultList
            className={cn(className)}
            component={SearchComponent.PRODUCT_RESULT_LIST}
            hits={hits}
            keyExtractor={(hit) => hit.objectID}
            HitComponent={({ hit }) => (
                <ContentResultListHitComponent hit={hit} />
            )}
        />
    );
};
